import React from 'react';
import { FormattedMessage } from 'react-intl';
import { toHumanString } from '../../../helpers/toHumanString';
import { PendingPostsBannerContainer, PendingPostsBannerMessage, PendingPostsBannerTitle, PendingPostsBannerTitleBadge, } from './styles';
export const PendingPostsBanner = ({ canReviewPosts, postsCount }) => {
    return (React.createElement(PendingPostsBannerContainer, null,
        React.createElement(PendingPostsBannerTitle, null,
            React.createElement(PendingPostsBannerTitleBadge, null),
            React.createElement(FormattedMessage, { id: "community.pendingPostsBanner.title" })),
        React.createElement(PendingPostsBannerMessage, null, canReviewPosts ? (React.createElement(FormattedMessage, { id: "community.pendingPostsBanner.needApproval", values: {
                amount: postsCount,
                formattedAmount: toHumanString(postsCount),
            } })) : (React.createElement(FormattedMessage, { id: "community.pendingPostsBanner.pendingForReview" })))));
};
//# sourceMappingURL=PendingPostsBanner.js.map